/**
 * Gets the current route from the browser's pathname.
 * Extracts the first path segment from the pathname.
 * Returns "/mapview" as default if no path segment is found.
 *
 * @returns The current route path
 */
export const getCurrentRoute = (): string => {
  if (typeof window !== "undefined") {
    const pathname = window.location.pathname.split("/")[1];
    return pathname ? `/${pathname}` : "/mapview";
  }
  return "/mapview";
};
